import california from "~/content/trafficInfo/ca/california.md"
import florida from "~/content/trafficInfo/fl/florida.md"
import georgia from "~/content/trafficInfo/ga/georgia.md"
import newJersey from "~/content/trafficInfo/nj/new-jersey.md"
import newYork from "~/content/trafficInfo/ny/new-york.md"
import pennsylvania from "~/content/trafficInfo/pa/pennsylvania.md"
import washington from "~/content/trafficInfo/wa/washington.md"

import bronx from "~/content/trafficInfo/ny/bronx.md"
import brooklynSouth from "~/content/trafficInfo/ny/brooklyn-south.md"
import brooklynNorth from "~/content/trafficInfo/ny/brooklyn-north.md"
import manhattanNorth from "~/content/trafficInfo/ny/manhattan-north.md"
import manhattanSouth from "~/content/trafficInfo/ny/manhattan-south.md"
import richmond from "~/content/trafficInfo/ny/richmond.md"
import queensNorth from "~/content/trafficInfo/ny/queens-north.md"
import queensSouth from "~/content/trafficInfo/ny/queens-south.md"
import suffolkCountyTrafficCourt from "~/content/trafficInfo/ny/suffolk-county-traffic-court.md"
import syracuse from "~/content/trafficInfo/ny/syracuse-city-court.md"
import nassauCounty from "~/content/trafficInfo/ny/nassau-county-traffic-court.md"

import nysEveryVTL from "~/content/trafficInfo/ny/nys-every-vtl-code.md"
import newYorkCityTVB from "~/content/trafficInfo/ny/nyc-tvb.md"
import floridaStatuses from "~/content/trafficInfo/fl/florida-statuses.md"

export const SUBMISSION_BASE_PATH = "/traffic-tickets"
export const INFORMATION_BASE_PATH = "/traffic/information"

export const STATES = {
  "ca-california": {
    title: "California",
    shortName: "CA",
    longName: "California",
    content: california,
    submissionSlug: "california"
  },
  "fl-florida": {
    title: "Florida",
    shortName: "FL",
    longName: "Florida",
    content: florida,
    submissionSlug: "florida"
  },
  "ga-georgia": {
    title: "Georgia",
    shortName: "GA",
    longName: "Georgia",
    content: georgia,
    submissionSlug: "georgia"
  },
  "ny-new-york": {
    title: "New York",
    shortName: "NY",
    longName: "New-York",
    content: newYork,
    submissionSlug: "ny",
  },
  "nj-new-jersey": {
    title: "New Jersey",
    description: "Did you get a traffic ticket in New Jersey? Learn how to fight your ticket and understand the penalties using our guide.",
    shortName: "NJ",
    longName: "New-Jersey",
    content: newJersey,
    submissionSlug: "nj",
  },
  "pa-pennsylvania": {
    title: "Pennsylvania",
    description: "Pennsylvania traffic ticket fines can break the bank, but there's much more to worry about. This information will help you better understand the ticket process.",
    shortName: "PA",
    longName: "Pennsylvania",
    content: pennsylvania,
    submissionSlug: "pa",
  },
  "tx-texas": {
    title: "Texas",
    shortName: "TX",
    longName: "Texas",
    content: null,
    submissionSlug: "tx",
  },
  "wa-washington": {
    title: "Washington",
    shortName: "WA",
    longName: "Washington",
    content: washington,
    submissionSlug: "washington",
  },
}

export const STATE_GENERAL_MAP = {
  "ca-california": {},
  "fl-florida": {
    "florida-status-codes": {
      title: "Florida Status Codes",
      content: floridaStatuses
    }
  },
  "ga-georgia": {},
  "mo-missouri": {},
  "nj-new-jersey": {},
  "ny-new-york": {
    "new-york-city-tvb": {
      title: "New York City Traffic Tickets (TVB Tickets)",
      shortTitle: "New York City TVB Tickets",
      description: "The dreaded TVB ticket is one that many New Yorkers recognize. On top of all federal and state rules of the road, the people of New York City also have to deal with the rules of the Traffic Violations Bureau. The TVB is an extension of the New York City government.",
      content: newYorkCityTVB
    },
    "nys-every-vtl-code": {
      title: "Every NYS VTL Code, Description, Point Value, Fine Amount Per Violation, and Estimated Insurance Premium Increase",
      shortTitle: "New York State VTL Codes",
      description: "Did you know that there are almost 1,000 ways to get a traffic ticket in NY? All of those ways are written out in the New York State Vehicle and Traffic Law (NYS VTL). Although most of them have the same or similar penalties, a few are unique.",
      content: nysEveryVTL
    },
  },
  "pa-pennsylvania": {},
  "wa-washington": {}
}

export const STATE_COUNTY_MAP = {
  "ca-california": {},
  "fl-florida": {},
  "ga-georgia": {},
  "mo-missouri": {},
  "nj-new-jersey": {},
  "ny-new-york": {
    "suffolk": {
      title: "Suffolk County Traffic Court",
      description: "Do you need help looking up, fighting, or paying a ticket in Suffolk County? Our guide will walk you through the entire Suffolk County ticket process.",
      content: suffolkCountyTrafficCourt
    },
    "nassau": {
      title: "Nassau County Traffic Court",
      description: "Traffic tickets in Nassau County are relatively the same as they are elsewhere in the state, with the exception of New York City. The most notable difference between Nassau County traffic tickets and New York City traffic tickets is the fact that the Traffic Violations Bureau does not have jurisdiction in Nassau County.",
      content: nassauCounty
    },
  },
  "pa-pennsylvania": {},
  "wa-washington": {}
}

export const STATE_COURT_MAP = {
  "ca-california": {},
  "fl-florida": {},
  "ga-georgia": {},
  "mo-missouri": {},
  "nj-new-jersey": {},
  "ny-new-york": {
    "bronx": {
      title: "Bronx TVB Traffic Tickets",
      description: "Traffic tickets are everywhere in the Bronx. To fight a Bronx TVB traffic ticket, you'll have to know what the Bronx TVB is.",
      content: bronx,
    },
    "brooklyn-south-coney-island": {
      title: "Brooklyn South TVB (Coney Island TVB)",
      description: "To fight a Coney Island traffic ticket, you'll have to beat the Brooklyn South TVB. WinIt's traffic lawyers can show you how.",
      content: brooklynSouth,
    },
    "brooklyn-north": {
      title: "Brooklyn North TVB",
      description: "Do you want to fight your Brooklyn North traffic ticket? Learn about the North Brooklyn Traffic Court and how to win your case.",
      content: brooklynNorth
    },
    "manhattan-north": {
      title: "Manhattan North TVB",
      description: "Did you get a traffic ticket in upper Manhattan? Learn how to fight Manhattan traffic tickets through the Manhattan North TVB.",
      content: manhattanNorth
    },
    "manhattan-south": {
      title: "Manhattan South TVB",
      description: "Did you get a ticket in lower Manhattan? Get all the information you need about the Manhattan South TVB and learn how to fight your ticket.",
      content: manhattanSouth
    },
    "richmond": {
      title: "Richmond TVB (Staten Island TVB)",
      description: "The Richmond TVB handles NYC traffic tickets in the Richmond area. If you get a speeding ticket in Staten Island, you'll have to deal with the Richmond TVB.",
      content: richmond
    },
    "queens-north": {
      title: "Queens North TVB",
      description: "Did you have a ticket to fight from the queens north traffic violations bureau? Let our experts win your case for you.",
      content: queensNorth
    },
    "queens-south": {
      title: "Queens South TVB",
      description: "Did you get a traffic ticket in Queens? Find information about the Queens South TVB and learn how we can help you fight your ticket.",
      content: queensSouth
    },
    "syracuse": {
      title: "Syracuse City Court",
      description: "Syracuse tickets can cost quite a bit of money. On top of the obvious fines, there is a whole list of other costs that you'll have to pay. Surcharges and additional fees are the main two. But a traffic ticket can also mean higher insurance rates.",
      content: syracuse
    },
  },
  "pa-pennsylvania": {},
  "wa-washington": {}
}
